import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

const Stars = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M29.083 12.75L27.1038 8.39587L22.7497 6.41671L27.1038 4.43754L29.083 0.083374L31.0622 4.43754L35.4163 6.41671L31.0622 8.39587L29.083 12.75ZM29.083 34.9167L27.1038 30.5625L22.7497 28.5834L27.1038 26.6042L29.083 22.25L31.0622 26.6042L35.4163 28.5834L31.0622 30.5625L29.083 34.9167ZM13.2497 30.1667L9.29134 21.4584L0.583008 17.5L9.29134 13.5417L13.2497 4.83337L17.208 13.5417L25.9163 17.5L17.208 21.4584L13.2497 30.1667ZM13.2497 22.4875L14.833 19.0834L18.2372 17.5L14.833 15.9167L13.2497 12.5125L11.6663 15.9167L8.26218 17.5L11.6663 19.0834L13.2497 22.4875Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};

export default Stars;
